import { Component, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { GeofencingMgtService } from '../../services/geofencing-mgt.service';
import { AppFilter } from '@app/shared/models';

interface IAssignProfileModalContext {
  data: any;
  title?: string;
}

@Component({
  selector: 'app-assign-geofence-profile',
  templateUrl: './assign-geofence-profile.component.html',
  styleUrls: ['./assign-geofence-profile.component.scss']
})
export class AssignGeofenceProfileComponent implements OnInit {
  selectedProfile: any;
  filter: AppFilter = new AppFilter();
  success:any;
  error:any;
  user:any;
  pending: boolean;
  rows: number = 2;
  profiles: any[] = [];
    constructor( public modal: SuiModal<IAssignProfileModalContext, void, void>,
      private geofenceSVC:GeofencingMgtService
    ) {
      this.filter = new AppFilter({
        sidx: 'dateCreated',
        rows: 10,
        sord: 'desc',
      });

      this.user = this.modal.context.data
     }
    
  
  
    ngOnInit(): void {
      this.getProfiles();
    }
assignGeofenceUser(profile){
  this.pending = true;
  this.geofenceSVC.assignGeofenceProfile({
    geofenceProfileId:profile.geoFenceProfileId,
    appUserId:this.user
  }).subscribe(
    (res)=>{
      this.pending = false;
      console.log(res,'this is res');
      this.success = "Geofence Profile Assigned Successfully"
    },
    (error) => {
      this.pending = false;
      this.error = error.error ? error.error : error;
    }

  )
}
    getProfiles() {
      this.filter.page = 1;
      this.pending = true;
      this.geofenceSVC.getGeofenceProfiles({ params: this.filter }).subscribe(
        (res: any) => {
          this.pending = false;
          this.profiles = res.rows;
        },
        (error) => {
          this.pending = false;
          this.error = error.error ? error.error : error;
        }
      );
    }

    onProfileChange() {
      console.log('Selected profile:', this.selectedProfile);
    }
}


export class AssignProfileModal extends ComponentModalConfig<
  IAssignProfileModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(AssignGeofenceProfileComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}